exports = module.exports = require("../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1nLYMzjMzRE1Td_ArATvEe{font-size:12px;font-weight:400;font-weight:600;height:39px;width:52px}html[dir] ._1nLYMzjMzRE1Td_ArATvEe{text-align:center}.NJO_XzTB6fnvC9QFJhOaS{font-size:12px;font-weight:400;font-weight:600;height:39px;width:100%;text-overflow:ellipsis;overflow:hidden}html[dir=ltr] .NJO_XzTB6fnvC9QFJhOaS{text-align:left;padding-left:10px}html[dir=rtl] .NJO_XzTB6fnvC9QFJhOaS{text-align:right;padding-right:10px}._2tQma7nv9qigiCYU7yW7Px{font-size:14px;font-weight:400}", ""]);
// Exports
exports.locals = {
	"initial": "_1nLYMzjMzRE1Td_ArATvEe",
	"name": "NJO_XzTB6fnvC9QFJhOaS",
	"icon": "_2tQma7nv9qigiCYU7yW7Px"
};